export default "__VITE_ASSET__0c1ea6ce__"